var csjs = require('csjs-inject')

const css = csjs`
  .debugger {
    margin-bottom: 1%;
  }
`

module.exports = css
